import styled, { keyframes } from 'styled-components'

const COLORS = {
  black: '#000000',
  darkGray: '#333333',
  blue: '#2251ff',
  lightGray: '#B3B3B3',
  borderGray: '#E6E6E6',
  white: '#FFFFFF',
  red: '#c8302d'
}

export const InfoLinksContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 12px;
  padding-bottom: 2px;
  font-family: 'McKinsey Sans', sans-serif;
`

export const InfoLinkRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  color: ${COLORS.darkGray};
  font-family: 'McKinsey Sans', sans-serif;
  font-size: 14px;
  margin-bottom: 2px;

  &:hover {
    color: ${COLORS.blue};
  }

  &:focus {
    /* outline: 2px solid ${COLORS.blue}; */
    outline-offset: 2px;
  }
`

export const InfoIconWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`

export const InfoLinkLabel = styled.span`
  font-weight: 400;
  font-family: 'McKinsey Sans', sans-serif;
`

export const DisclaimerParagraph = styled.p`
  margin: 0 0 12px 0;
  padding-bottom: 2px;
  color: ${COLORS.darkGray};
  font-family: 'McKinsey Sans', sans-serif;
  font-size: 14px;
  line-height: 1.5;
  font-weight: ${(p) => (p.$bold ? 700 : 400)};

  &:last-of-type {
    margin-bottom: 0;
  }
`

const around = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`

export const ChargeCodeContent = styled.div`
  padding: 10px 0;
  padding-bottom: 12px;
  color: ${COLORS.darkGray};
  font-family: 'McKinsey Sans', sans-serif;
  font-size: 14px;
  line-height: 1.5;
`

export const PricingSubHeading = styled.div`
  font-weight: 700;
  margin: 0 0 12px 0;
  padding-bottom: 2px;
  color: ${COLORS.darkGray};
  font-family: 'McKinsey Sans', sans-serif;
  font-size: 14px;
`

export const PricingList = styled.ul`
  margin: 0 0 12px 0;
  padding-left: 20px;
  padding-bottom: 2px;
  color: ${COLORS.darkGray};
  font-family: 'McKinsey Sans', sans-serif;
  font-size: 14px;
  line-height: 1.6;
`

export const PricingListItem = styled.li`
  margin-bottom: 8px;
  font-family: 'McKinsey Sans', sans-serif;

  &:last-child {
    margin-bottom: 0;
  }
`

export const PricingItemLabel = styled.span`
  font-weight: 700;
  font-family: 'McKinsey Sans', sans-serif;
`

export const ContactParagraph = styled.p`
  margin: 0;
  padding-bottom: 2px;
  color: ${COLORS.darkGray};
  font-family: 'McKinsey Sans', sans-serif;
  font-size: 14px;
  line-height: 1.5;
`

export const ContactLink = styled.a`
  color: ${COLORS.blue};
  text-decoration: underline;
  font-family: 'McKinsey Sans', sans-serif;
  font-size: 14px;

  &:hover {
    text-decoration: underline;
  }
`

export const StyledHr = styled.hr`
  margin: 15px 0;
  margin-bottom: 17px;
  border: 1px solid ${COLORS.borderGray};
`

export const ChargeCodeBodyContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-bottom: 2px;
  font-family: 'McKinsey Sans', sans-serif;
`

export const ChargeCodeInputTitle = styled.div`
  color: ${(p) => (p.$blue ? COLORS.blue : COLORS.darkGray)};
  font-family: 'McKinsey Sans', sans-serif;
  font-size: 16px;
  margin-bottom: 2px;
  white-space: nowrap;
`

export const InputRowsGrid = styled.div`
  display: grid;
  grid-template-columns: 110px 1fr auto;
  gap: 12px 12px;
  align-items: center;
  margin-bottom: 2px;
`

export const ChargeCodeRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 2px;
`

export const ChargeCodeInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  margin-bottom: 2px;
  min-width: 0;
`

export const EdEmailRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 2px;
`

export const EdEmailCheckboxLabel = styled.label`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  color: ${COLORS.darkGray};
  font-family: 'McKinsey Sans', sans-serif;
  font-size: 14px;
  user-select: none;
  margin-bottom: 2px;
`

export const AgreementCheckboxRow = styled.label`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  cursor: pointer;
  color: ${COLORS.darkGray};
  font-family: 'McKinsey Sans', sans-serif;
  font-size: 14px;
  line-height: 1.5;
  user-select: none;
  margin: 0 0 2px 0;

  input {
    flex-shrink: 0;
    margin-top: 2px;
  }
`

export const Loader = styled.div`
  position: relative;
  color: ${COLORS.blue};
  height: 20px;
  width: 20px;
  display: inline-block;
  &::after,
  &::before {
    content: '';
    position: absolute;
    display: inline-block;
    width: 100%;
    height: 100%;
    border-width: 2px;
    border-color: ${COLORS.darkGray} ${COLORS.darkGray} transparent transparent;
    border-style: solid;
    border-radius: 20px;
    box-sizing: border-box;
    top: 0;
    left: 0;
    animation: ${around} 0.7s ease-in-out infinite;
  }
  &::after {
    animation: ${around} 0.7s ease-in-out 0.1s infinite;
    background: transparent;
  }
`

export const LoaderIconContainer = styled.div`
  position: absolute;
  right: 10px;
  top: calc(50% - 10px);
`

export const ChargeCodeInput = styled.input`
  display: flex;
  padding: 10px;
  align-items: center;
  border: 1px solid ${(p) => (p.$isValid === false ? COLORS.red : COLORS.lightGray)};
  background: ${COLORS.white};
  font-family: 'McKinsey Sans', sans-serif;
  font-size: 14px;
`

export const InvalidChargeCode = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  color: ${COLORS.red};
  font-family: 'McKinsey Sans', sans-serif;
  font-size: 14px;
  margin-bottom: 2px;
`

export const NoChargeCodeContainer = styled.div`
  display: flex;
  padding: 10px 0;
  padding-bottom: 12px;
  gap: 5px;
  justify-content: center;
  font-family: 'McKinsey Sans', sans-serif;
`

export const NoChargeCode = styled.span`
  color: ${COLORS.black};
  text-align: center;
  font-family: 'McKinsey Sans', sans-serif;
  font-size: 16px;
`

export const NoChargeCodeLink = styled.span`
  color: ${COLORS.blue};
  font-family: 'McKinsey Sans', sans-serif;
  font-size: 16px;
  text-decoration-line: underline;
  cursor: pointer;
`
